import React, { Suspense, lazy } from 'react';
import AuthProvider from 'api/context';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Main from 'Main';

// CRM Frontend Application - Version bump for release

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './App.css';
import { initializeFaroTracing } from './tracing';

const IFrame = lazy(() => import('IFrame'));
const IframeApiDocs = lazy(() => import('Documentation/IframeApi'));

const App = () => {
  React.useEffect(() => {
    // Initialize Faro tracing on app startup
    initializeFaroTracing();
  }, []);
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Switch>
          <Route path="/iframe/:uid?" component={IFrame} />
          <Route path="/documentation/iframe-api/:doc?" component={IframeApiDocs} />
          <Route>
            <AuthProvider>
              <Main />
            </AuthProvider>
          </Route>
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
